<template>
  <VCard class="payment-coupon-wrapper">
    <VBlock class="payment-coupon" :sort="Sort.space_between">
      <VSpan text="할인쿠폰" :size="16" :spacing="-0.35" :color="TextColor.darkGray" />
      <VA :onClick="onCoupon" class="coupon-button">
        <VSpan
          v-show="coupon.use"
          class="detail"
          :type="TextType.Number"
          :text="`${coupon.selected.length}개 적용`"
          :size="14"
          :spacing="-0.35"
          :color="TextColor.gray"
        />
        <VBlock>
          <VSpan
            v-show="!coupon.use"
            class="detail"
            :text="`${coupon.options.length}개 보유`"
            :size="14"
            :spacing="-0.35"
            :color="TextColor.gray2"
          />
          <div class="image-wrapper">
            <img :src="resources.foldIcon" :style="{ transform: 'rotate(-90deg)' }" />
          </div>
          <!-- </dlv> -->
        </VBlock>
      </VA>
    </VBlock>
  </VCard>
</template>

<script>
import VBlock, { Direction, Sort } from '../../molecules/VBlock/index'
import VSpan, { TextColor, TextType } from '../../atoms/VSpan/index'
import VA from '../../molecules/VA/index'
import VCard, { ColorType } from '../../molecules/VCard/index'

import foldIcon from '@/assets/images/fold-icon.svg'

export default {
  name: 'PreOrderPaymentCoupon',
  components: { VA, VSpan, VBlock, VCard },
  props: {
    coupon: {
      type: Object,
      required: true
    },
    onCoupon: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      Direction,
      Sort,
      TextColor,
      TextType,
      ColorType,

      resources: {
        foldIcon
      }
    }
  },
  computed: {
    totalSelectedCouponPrice() {
      return this.coupon.selected.reduce((acc, e) => acc + e.amount, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.payment-coupon-wrapper {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid $light-gray-8;

  .payment-coupon {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 21px 15px 19px;
    align-items: center;

    .coupon-button {
      display: flex;
      justify-content: center;
      align-items: center;
      .image-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 22px;
        padding-bottom: 1px;
      }
    }

    .detail {
      margin-right: 4px;
      vertical-align: middle;
    }
  }
}
</style>
